module.exports = __webpack_public_path__ + "assets/img/cancer.7fdc9def.png";